// extracted by mini-css-extract-plugin
export default {"left":"aIZr0G","external":"bIZr0G","center":"cIZr0G","right":"dIZr0G"};